// Language configuration and translations
export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];

export const translations = {
  en: {
    // Header / Nav
    petechtor: "PETECHTOR",
    guardiansOfPets: "Guardians of Pets",
    rainbowRoomNav: "Rainbow Room",
    howItWorksNav: "How it works",
    joinGuardians: "Join the Guardians",

    // Hero - Logo area
    heroProtectWhileHere: "Protect While Here",
    heroHonorForever: "Honor Forever",

    // Hero - Badges
    heroBadgeRainbowRoom: "Rainbow Room",
    heroBadgeNoPetLeft: "No pet left behind",

    // Hero - Subtitle / Heading
    heroSubtitle: "A sacred mission: protect every pet today, honor their memory forever.",
    heroGuardiansOfPetverse: "Guardians of the Petverse",

    // Hero - Description
    heroDescriptionPre: "Petechtor stands for one simple truth:",
    heroDescriptionBold: "protect while here, honor forever.",
    heroDescriptionPost: "We help guardians care for the pets who give us everything — and when the time comes, the Rainbow Room offers a sacred place to honor their memory.",

    // Hero - Rainbow Room Beta Invite
    heroBetaInviteBadge: "Open",
    heroBetaInviteTitle: "The first real 3D pet memorial you can enter and experience as a living scene.",
    heroBetaInviteText: "Open. One shared garden. Sugar stays in the Demo. Go in, hear Echo, and open a memory.",
    heroBetaInviteText2: "You can add a photo of your pet just like in the Demo.",
    heroBetaInviteText3: "Just click \"Ask for a place.\" It costs you nothing.",
    rainbowRoomPopupText: "You finished step 1 in the Rainbow Room. To add your pet, two more things are required: leave your feedback below, and join the waitlist. Both are needed before your pet can be added.",
    rainbowRoomPopupFeedbackBtn: "Leave feedback",
    rainbowRoomPopupWaitlistBtn: "Join the waitlist",

    // Hero - CTAs
    heroEnterBeta: "Enter the garden",
    heroJoinGuardiansBtn: "🐾 Join the Guardians",
    heroPrivateBetaNote: "Walk Sugar's garden. She has passed. This is so you can feel a room. The walk is not your pet's place.",

    // Hero - Why We Protect
    heroWhyWeProtect: "Why We Protect",
    heroWhyWeProtectText: "Our pets protect us without thought. They stand by us when we're low, guard us when we're scared, and give their whole heart unconditionally. That's the quiet bond we stand for. As Petechtor Guardians, we protect them back — because the one reason we should always shield our pets is because they shield us without hesitation. So every Guardian is both protector and protected.",

    // Hero - Aside Rainbow Room Panel
    heroAsideBadge: "Open",
    heroAsideTitle: "THE RAINBOW ROOM",
    heroAsideText: "Open. One garden. A place for a pet still here, or for one who has passed.",
    heroAsideEnterBeta: "Enter the garden",
    heroTagMemorial: "Memorial Tributes",
    heroTagCommunity: "Community Support",
    heroTagFeedback: "Feedback Welcome",
    heroAsideFooterNote: "Future guardian services — real-world protection tools and community support — will connect through the main Petechtor platform, always in service of this same mission.",

    // Three Pillars
    pillarsCoreLanes: "Core lanes",
    pillarsHeading: "Protection today. Honor forever.",
    pillarsLegend: "Open = live now with your feedback · Future = planned ahead",
    pillarRainbowRoomDesc: "Open. One garden. A place for a pet still here, or for one who has passed.",
    pillarStatusPrivateBeta: "Open",
    pillarSupaGeneTitle: "SupaGene DNA",
    pillarSupaGeneDesc: "A future addition for pet identity verification — details shared as our community grows.",
    pillarStatusFuture: "Future",
    pillarCommunityFundingTitle: "Community Funding",
    pillarCommunityFundingDesc: "Future donation and rescue-support flows, connecting through the main Petechtor platform.",
    pillarEnterBeta: "Enter the garden →",

    // How It Works
    howItWorksLabel: "How Guardians Roll",
    howItWorksHeading: "From a shared moment to real-world protection.",
    stepWord: "Step",
    step1Title: "Share their story",
    step1Desc: "Share a photo or memory of your pet — a joyful moment, a rescue story, or a tribute for the Rainbow Room.",
    step2Title: "Claim Guardian perks",
    step2Desc: "Earn badges, drops, and access for participating: tributes, votes, DNA submissions, and emergency-drive campaigns.",
    step3Title: "Route the blessings",
    step3Desc: "Support flows to rescue partners, memorial care, and the infrastructure that keeps every pet story online — forever.",

    // Trust Block
    trustLabel: "Trust & Transparency",
    trustHeading: "Built for Every Guardian – Full Transparency",
    trust1Title: "Community-First",
    trust1Desc: "No hidden agendas — built for guardians, not profit",
    trust2Title: "Open Roadmap",
    trust2Desc: "Plans shared openly as our community and the Rainbow Room grow",
    trust3Title: "Guardian Values",
    trust3Desc: "Compassion first — not financial advice",
    trust4Title: "Protection First",
    trust4Desc: "We stand for every pet, unconditionally",

    // Join Section
    joinHeading: "Add Your Paw & Claw – Become a Guardian",
    joinStandWithUs: "Stand with us to protect every pet.",
    joinText1: "Free, for a pet who is here or a pet who has passed. We open places a few at a time. Yours stays.",
    joinText2: "Our pets protect us without thought, so we protect them back — unconditionally.",
    joinText3: "Get early updates when there's more to share, and help shape the mission as a community when ready.",
    joinDetailsStay: "Your details stay with us. No spam, just protection vibes.",
    joinPledgeLabel: "Guardian Join & Pledge",
    joinNamePlaceholder: "Your name",
    joinEmailPlaceholder: "you@example.com",
    joinNotePlaceholder: "Interest / short note",
    joinErrorName: "Please enter your name",
    joinErrorEmail: "Please enter your email",
    joinErrorValidEmail: "Please enter a valid email",
    joinErrorFailed: "Failed to join waitlist",
    joinSuccessMsg: "✓ Successfully joined the waitlist!",
    joinSubmitBtn: "Request a place",
    joinSubmittingBtn: "Joining...",
    joinJoinedBtn: "Joined ✓",
    joinClearBtn: "Clear",

    // Guardian Feed
    feedLabel: "Guardian Feed",
    feedHeading: "Guardians feed the timeline.",

    // Petverse Preview
    petverseHeading: "Sneak Peek at the Petverse",
    petverseText: "A behind-the-scenes look at how we're building ways to protect and stand for every sidekick — together.",
    petverseVisit: "Visit petechtor.com",

    // Rainbow Room Feedback Form
    feedbackHeading: "After you've been inside",
    feedbackSuccess: "Thank you, Guardian. We've got the watch.",
    feedbackNamePlaceholder: "Name*",
    feedbackEmailPlaceholder: "Email*",
    feedbackPetNamePlaceholder: "Pet name",
    feedbackWalkQuestion: "Did the Rainbow Room open and could you look around?*",
    feedbackWalkYes: "Yes",
    feedbackWalkMostly: "Mostly",
    feedbackWalkNo: "No",
    feedbackPeacefulQuestion: "Peaceful? (1-5)*",
    feedbackPeacefulHelper: "1 = least peaceful · 5 = most peaceful",
    feedbackFixFirstPlaceholder: "Leave your feedback here*",
    feedbackSubmitBtn: "Send feedback",
    feedbackSendingBtn: "Sending...",
    feedbackErrorName: "Please enter your name",
    feedbackErrorEmail: "Please enter a valid email",
    feedbackErrorWalk: "Please answer: Did the Rainbow Room open and could you look around?",
    feedbackErrorPeaceful: "Please rate how peaceful it felt",
    feedbackErrorFixFirst: "Please tell us what to fix first",

    // Share Buttons
    shareInviteLabel: "Know a fellow Guardian? Share this with them:",
    shareMessage: "I just joined the Petechtor Guardians waitlist — protecting pets, honoring their memory forever. Join me:",
    shareCopyLink: "Copy Link",
    shareCopied: "Copied!",

    // Footer
    footerCopyright: "© Guardians of the Petverse. Protect while here, honor forever.",
    footerDisclaimer: "Petechtor is a community-first project focused on protecting pets. Always DYOR.",

    // Personal Logo Upload
    personalLogoUploadTooltip: "Upload your pet's photo",
    personalLogoUploadTitle: "Upload Pet Photo",
    personalLogoReset: "Reset to Default",
    personalLogoVisibleOnly: "Visible only to you",

    // Pet Clock
    clockCaption: "Every Second Matters.",
    clockUploadHint: "Tap a hand's photo to add your pet",
    clockUploadLogoBtn: "Upload Logo",
    clockUseDefaultCrestBtn: "Use Default Crest",
    clockHandUploadTooltip: "Upload a pet photo",
    clockCenterLogoTooltip: "Upload a custom center logo"
  },

  es: {
    petechtor: "PETECHTOR",
    guardiansOfPets: "Guardianes de Mascotas",
    rainbowRoomNav: "Sala del Arcoíris",
    howItWorksNav: "Cómo funciona",
    joinGuardians: "Únete a los Guardianes",

    heroProtectWhileHere: "Proteger Mientras Están Aquí",
    heroHonorForever: "Honrar Para Siempre",

    heroBadgeRainbowRoom: "Sala del Arcoíris",
    heroBadgeNoPetLeft: "Ninguna mascota queda atrás",

    heroSubtitle: "Una misión sagrada: proteger a cada mascota hoy, honrar su memoria para siempre.",
    heroGuardiansOfPetverse: "Guardianes del Petverso",

    heroDescriptionPre: "Petechtor representa una verdad simple:",
    heroDescriptionBold: "proteger mientras están aquí, honrar para siempre.",
    heroDescriptionPost: "Ayudamos a los guardianes a cuidar de las mascotas que nos lo dan todo — y cuando llega el momento, la Sala del Arcoíris ofrece un lugar sagrado para honrar su memoria.",

    heroBetaInviteBadge: "Abierto",
    heroBetaInviteTitle: "El primer memorial 3D real para mascotas que puedes entrar y vivir como una escena viva.",
    heroBetaInviteText: "Abierto. Un jardín compartido. Sugar permanece en la Demo. Entra, escucha a Echo y abre un recuerdo.",
    heroBetaInviteText2: "Puedes añadir una foto de tu mascota tal como en la Demo.",
    heroBetaInviteText3: "Solo haz clic en \"Solicitar un lugar\". No te cuesta nada.",
    rainbowRoomPopupText: "Completaste el paso 1 en la Sala del Arcoíris. Para añadir a tu mascota, se necesitan dos cosas más: deja tu opinión abajo y únete a la lista de espera. Ambas son necesarias antes de poder añadir a tu mascota.",
    rainbowRoomPopupFeedbackBtn: "Dejar comentario",
    rainbowRoomPopupWaitlistBtn: "Unirse a la lista",

    heroEnterBeta: "Entrar al jardín",
    heroJoinGuardiansBtn: "🐾 Únete a los Guardianes",
    heroPrivateBetaNote: "Camina por el jardín de Sugar. Ella ha fallecido. Esto es para que puedas sentir una sala. El paseo no es el lugar de tu mascota.",

    heroWhyWeProtect: "Por Qué Protegemos",
    heroWhyWeProtectText: "Nuestras mascotas nos protegen sin pensarlo. Están a nuestro lado cuando estamos decaídos, nos cuidan cuando tenemos miedo, y dan todo su corazón sin condiciones. Ese es el vínculo silencioso que defendemos. Como Guardianes de Petechtor, las protegemos a ellas — porque la razón por la que siempre debemos proteger a nuestras mascotas es que ellas nos protegen sin dudarlo. Así que cada Guardián es protector y protegido a la vez.",

    heroAsideBadge: "Abierto",
    heroAsideTitle: "LA SALA DEL ARCOÍRIS",
    heroAsideText: "Abierto. Un jardín. Un lugar para una mascota que sigue aquí, o para una que ha fallecido.",
    heroAsideEnterBeta: "Entrar al jardín",
    heroTagMemorial: "Tributos Conmemorativos",
    heroTagCommunity: "Apoyo Comunitario",
    heroTagFeedback: "Comentarios Bienvenidos",
    heroAsideFooterNote: "Los futuros servicios de guardianes — herramientas de protección reales y apoyo comunitario — se conectarán a través de la plataforma principal de Petechtor, siempre al servicio de esta misma misión.",

    // Three Pillars
    pillarsCoreLanes: "Líneas principales",
    pillarsHeading: "Protección hoy. Honor para siempre.",
    pillarsLegend: "Abierto = activo ahora con tu opinión · Futuro = planeado",
    pillarRainbowRoomDesc: "Abierto. Un jardín. Un lugar para una mascota que sigue aquí, o para una que ha fallecido.",
    pillarStatusPrivateBeta: "Abierto",
    pillarSupaGeneTitle: "SupaGene DNA",
    pillarSupaGeneDesc: "Una futura función para la verificación de identidad de mascotas — detalles compartidos a medida que crece nuestra comunidad.",
    pillarStatusFuture: "Futuro",
    pillarCommunityFundingTitle: "Financiación Comunitaria",
    pillarCommunityFundingDesc: "Futuros flujos de donación y apoyo a rescates, conectados a través de la plataforma principal de Petechtor.",
    pillarEnterBeta: "Entrar al jardín →",

    howItWorksLabel: "Cómo Actúan los Guardianes",
    howItWorksHeading: "De un momento compartido a la protección real.",
    stepWord: "Paso",
    step1Title: "Comparte su historia",
    step1Desc: "Comparte una foto o recuerdo de tu mascota — un momento feliz, una historia de rescate o un tributo para la Sala del Arcoíris.",
    step2Title: "Reclama beneficios de Guardián",
    step2Desc: "Gana insignias, sorteos y acceso por participar: tributos, votos, envíos de ADN y campañas de emergencia.",
    step3Title: "Encamina las bendiciones",
    step3Desc: "El apoyo fluye hacia socios de rescate, cuidado conmemorativo, y la infraestructura que mantiene cada historia de mascota en línea — para siempre.",

    trustLabel: "Confianza y Transparencia",
    trustHeading: "Hecho para Cada Guardián – Transparencia Total",
    trust1Title: "Comunidad Primero",
    trust1Desc: "Sin agendas ocultas — hecho para guardianes, no para ganancias",
    trust2Title: "Hoja de Ruta Abierta",
    trust2Desc: "Planes compartidos abiertamente a medida que crece nuestra comunidad y la Sala del Arcoíris",
    trust3Title: "Valores del Guardián",
    trust3Desc: "Compasión primero — no es asesoría financiera",
    trust4Title: "Protección Primero",
    trust4Desc: "Defendemos a cada mascota, sin condiciones",

    joinHeading: "Suma Tu Pata y Garra – Conviértete en Guardián",
    joinStandWithUs: "Apóyanos para proteger a cada mascota.",
    joinText1: "Gratis, para una mascota que está aquí o una que ha fallecido. Abrimos lugares de pocos en pocos. El tuyo se queda.",
    joinText2: "Nuestras mascotas nos protegen sin pensarlo, así que las protegemos a ellas — sin condiciones.",
    joinText3: "Recibe actualizaciones anticipadas cuando haya más que compartir, y ayuda a dar forma a la misión como comunidad cuando llegue el momento.",
    joinDetailsStay: "Tus datos se quedan con nosotros. Sin spam, solo buena onda de protección.",
    joinPledgeLabel: "Adhesión y Compromiso del Guardián",
    joinNamePlaceholder: "Tu nombre",
    joinEmailPlaceholder: "tu@ejemplo.com",
    joinNotePlaceholder: "Interés / nota breve",
    joinErrorName: "Por favor ingresa tu nombre",
    joinErrorEmail: "Por favor ingresa tu correo",
    joinErrorValidEmail: "Por favor ingresa un correo válido",
    joinErrorFailed: "No se pudo unir a la lista de espera",
    joinSuccessMsg: "✓ ¡Te uniste a la lista de espera con éxito!",
    joinSubmitBtn: "Solicitar un lugar",
    joinSubmittingBtn: "Uniendo...",
    joinJoinedBtn: "Unido ✓",
    joinClearBtn: "Limpiar",

    feedLabel: "Feed de Guardianes",
    feedHeading: "Los Guardianes alimentan la línea de tiempo.",

    petverseHeading: "Vista Previa del Petverso",
    petverseText: "Una mirada detrás de escena de cómo construimos formas de proteger y defender a cada compañero — juntos.",
    petverseVisit: "Visita petechtor.com",

    feedbackHeading: "Después de haber estado dentro",
    feedbackSuccess: "Gracias, Guardián. Tenemos la guardia.",
    feedbackNamePlaceholder: "Nombre*",
    feedbackEmailPlaceholder: "Correo*",
    feedbackPetNamePlaceholder: "Nombre de la mascota",
    feedbackWalkQuestion: "¿Se abrió la Sala del Arcoíris y pudiste mirar alrededor?*",
    feedbackWalkYes: "Sí",
    feedbackWalkMostly: "Mayormente",
    feedbackWalkNo: "No",
    feedbackPeacefulQuestion: "¿Fue pacífico? (1-5)*",
    feedbackPeacefulHelper: "1 = menos pacífico · 5 = más pacífico",
    feedbackFixFirstPlaceholder: "Deja tu comentario aquí*",
    feedbackSubmitBtn: "Enviar opinión",
    feedbackSendingBtn: "Enviando...",
    feedbackErrorName: "Por favor ingresa tu nombre",
    feedbackErrorEmail: "Por favor ingresa un correo válido",
    feedbackErrorWalk: "Por favor responde: ¿Se abrió la Sala del Arcoíris y pudiste mirar alrededor?",
    feedbackErrorPeaceful: "Por favor califica qué tan pacífico se sintió",
    feedbackErrorFixFirst: "Por favor dinos qué arreglar primero",

    shareInviteLabel: "¿Conoces a otro Guardián? Comparte esto con ellos:",
    shareMessage: "Acabo de unirme a la lista de espera de los Guardianes de Petechtor — protegiendo mascotas, honrando su memoria para siempre. Únete a mí:",
    shareCopyLink: "Copiar Enlace",
    shareCopied: "¡Copiado!",

    footerCopyright: "© Guardianes del Petverso. Proteger mientras están aquí, honrar para siempre.",
    footerDisclaimer: "Petechtor es un proyecto centrado en la comunidad enfocado en proteger mascotas. Siempre investiga por tu cuenta.",

    personalLogoUploadTooltip: "Sube la foto de tu mascota",
    personalLogoUploadTitle: "Subir Foto de Mascota",
    personalLogoReset: "Restablecer al Predeterminado",
    personalLogoVisibleOnly: "Visible solo para ti",

    clockCaption: "Cada Segundo Cuenta.",
    clockUploadHint: "Toca la foto de una mano para agregar tu mascota",
    clockUploadLogoBtn: "Subir Logo",
    clockUseDefaultCrestBtn: "Usar Escudo Predeterminado",
    clockHandUploadTooltip: "Sube la foto de una mascota",
    clockCenterLogoTooltip: "Sube un logo central personalizado"
  },

  fr: {
    petechtor: "PETECHTOR",
    guardiansOfPets: "Gardiens des Animaux",
    rainbowRoomNav: "Salle Arc-en-Ciel",
    howItWorksNav: "Comment ça marche",
    joinGuardians: "Rejoindre les Gardiens",

    heroProtectWhileHere: "Protéger Ici-Bas",
    heroHonorForever: "Honorer à Jamais",

    heroBadgeRainbowRoom: "Salle Arc-en-Ciel",
    heroBadgeNoPetLeft: "Aucun animal laissé derrière",

    heroSubtitle: "Une mission sacrée : protéger chaque animal aujourd'hui, honorer sa mémoire pour toujours.",
    heroGuardiansOfPetverse: "Gardiens du Petverse",

    heroDescriptionPre: "Petechtor défend une vérité simple :",
    heroDescriptionBold: "protéger ici-bas, honorer à jamais.",
    heroDescriptionPost: "Nous aidons les gardiens à prendre soin des animaux qui nous donnent tout — et quand le moment arrive, la Salle Arc-en-Ciel offre un lieu sacré pour honorer leur mémoire.",

    heroBetaInviteBadge: "Ouvert",
    heroBetaInviteTitle: "Le premier véritable mémorial 3D pour animaux que vous pouvez visiter et vivre comme une scène vivante.",
    heroBetaInviteText: "Ouvert. Un jardin partagé. Sugar reste dans la Démo. Entrez, écoutez Echo et ouvrez un souvenir.",
    heroBetaInviteText2: "Vous pouvez ajouter une photo de votre animal, tout comme dans la Démo.",
    heroBetaInviteText3: "Cliquez simplement sur « Demander une place ». Cela ne vous coûte rien.",
    rainbowRoomPopupText: "Vous avez terminé l'étape 1 dans la Salle Arc-en-Ciel. Pour ajouter votre animal, deux choses supplémentaires sont nécessaires : laissez votre avis ci-dessous et rejoignez la liste d'attente. Les deux sont nécessaires avant que votre animal puisse être ajouté.",
    rainbowRoomPopupFeedbackBtn: "Laisser un avis",
    rainbowRoomPopupWaitlistBtn: "Rejoindre la liste",

    heroEnterBeta: "Entrer dans le jardin",
    heroJoinGuardiansBtn: "🐾 Rejoindre les Gardiens",
    heroPrivateBetaNote: "Parcourez le jardin de Sugar. Elle est décédée. C'est pour que vous puissiez ressentir une salle. La visite n'est pas la place de votre animal.",

    heroWhyWeProtect: "Pourquoi Nous Protégeons",
    heroWhyWeProtectText: "Nos animaux nous protègent sans même y penser. Ils restent à nos côtés quand nous sommes abattus, nous veillent quand nous avons peur, et donnent tout leur cœur sans condition. C'est le lien silencieux que nous défendons. En tant que Gardiens Petechtor, nous les protégeons en retour — car la raison pour laquelle nous devons toujours protéger nos animaux, c'est qu'ils nous protègent sans hésiter. Ainsi, chaque Gardien est à la fois protecteur et protégé.",

    heroAsideBadge: "Ouvert",
    heroAsideTitle: "LA SALLE ARC-EN-CIEL",
    heroAsideText: "Ouvert. Un jardin. Une place pour un animal encore ici, ou pour un qui est décédé.",
    heroAsideEnterBeta: "Entrer dans le jardin",
    heroTagMemorial: "Hommages Commémoratifs",
    heroTagCommunity: "Soutien Communautaire",
    heroTagFeedback: "Avis Bienvenus",
    heroAsideFooterNote: "Les futurs services aux gardiens — outils de protection réels et soutien communautaire — se connecteront via la plateforme principale de Petechtor, toujours au service de cette même mission.",

    // Three Pillars
    pillarsCoreLanes: "Axes principaux",
    pillarsHeading: "Protection aujourd'hui. Honneur pour toujours.",
    pillarsLegend: "Ouvert = actif maintenant avec votre avis · Futur = prévu",
    pillarRainbowRoomDesc: "Ouvert. Un jardin. Une place pour un animal encore ici, ou pour un qui est décédé.",
    pillarStatusPrivateBeta: "Ouvert",
    pillarSupaGeneTitle: "SupaGene ADN",
    pillarSupaGeneDesc: "Un futur ajout pour la vérification d'identité des animaux — détails partagés à mesure que notre communauté grandit.",
    pillarStatusFuture: "Futur",
    pillarCommunityFundingTitle: "Financement Communautaire",
    pillarCommunityFundingDesc: "Futurs flux de dons et de soutien aux sauvetages, connectés via la plateforme principale de Petechtor.",
    pillarEnterBeta: "Entrer dans le jardin →",

    howItWorksLabel: "Comment Agissent les Gardiens",
    howItWorksHeading: "D'un moment partagé à une protection réelle.",
    stepWord: "Étape",
    step1Title: "Partagez son histoire",
    step1Desc: "Partagez une photo ou un souvenir de votre animal — un moment joyeux, une histoire de sauvetage ou un hommage pour la Salle Arc-en-Ciel.",
    step2Title: "Réclamez les avantages Gardien",
    step2Desc: "Gagnez des badges, des tirages et un accès en participant : hommages, votes, soumissions d'ADN et campagnes d'urgence.",
    step3Title: "Acheminez les bénédictions",
    step3Desc: "Le soutien afflue vers les partenaires de sauvetage, les soins commémoratifs, et l'infrastructure qui garde chaque histoire d'animal en ligne — pour toujours.",

    trustLabel: "Confiance et Transparence",
    trustHeading: "Conçu pour Chaque Gardien – Transparence Totale",
    trust1Title: "Communauté d'Abord",
    trust1Desc: "Aucun agenda caché — conçu pour les gardiens, pas pour le profit",
    trust2Title: "Feuille de Route Ouverte",
    trust2Desc: "Plans partagés ouvertement à mesure que notre communauté et la Salle Arc-en-Ciel grandissent",
    trust3Title: "Valeurs du Gardien",
    trust3Desc: "La compassion d'abord — ce n'est pas un conseil financier",
    trust4Title: "Protection d'Abord",
    trust4Desc: "Nous défendons chaque animal, sans condition",

    joinHeading: "Ajoutez Votre Patte & Griffe – Devenez Gardien",
    joinStandWithUs: "Soutenez-nous pour protéger chaque animal.",
    joinText1: "Gratuit, pour un animal qui est ici ou un animal qui est décédé. Nous ouvrons des places quelques-unes à la fois. La vôtre reste.",
    joinText2: "Nos animaux nous protègent sans y penser, alors nous les protégeons en retour — sans condition.",
    joinText3: "Recevez des mises à jour anticipées quand il y aura plus à partager, et aidez à façonner la mission en communauté quand le moment sera venu.",
    joinDetailsStay: "Vos informations restent avec nous. Pas de spam, juste de bonnes vibrations de protection.",
    joinPledgeLabel: "Adhésion et Engagement du Gardien",
    joinNamePlaceholder: "Votre nom",
    joinEmailPlaceholder: "vous@exemple.com",
    joinNotePlaceholder: "Intérêt / courte note",
    joinErrorName: "Veuillez entrer votre nom",
    joinErrorEmail: "Veuillez entrer votre e-mail",
    joinErrorValidEmail: "Veuillez entrer un e-mail valide",
    joinErrorFailed: "Impossible de rejoindre la liste d'attente",
    joinSuccessMsg: "✓ Vous avez rejoint la liste d'attente avec succès !",
    joinSubmitBtn: "Demander une place",
    joinSubmittingBtn: "Inscription...",
    joinJoinedBtn: "Inscrit ✓",
    joinClearBtn: "Effacer",

    feedLabel: "Fil des Gardiens",
    feedHeading: "Les Gardiens alimentent le fil d'actualité.",

    petverseHeading: "Aperçu du Petverse",
    petverseText: "Un regard dans les coulisses sur la façon dont nous construisons des moyens de protéger et de défendre chaque compagnon — ensemble.",
    petverseVisit: "Visitez petechtor.com",

    feedbackHeading: "Après votre visite",
    feedbackSuccess: "Merci, Gardien. Nous prenons le relais.",
    feedbackNamePlaceholder: "Nom*",
    feedbackEmailPlaceholder: "E-mail*",
    feedbackPetNamePlaceholder: "Nom de l'animal",
    feedbackWalkQuestion: "La Salle Arc-en-Ciel s'est-elle ouverte et avez-vous pu regarder autour de vous ?*",
    feedbackWalkYes: "Oui",
    feedbackWalkMostly: "Presque",
    feedbackWalkNo: "Non",
    feedbackPeacefulQuestion: "Paisible ? (1-5)*",
    feedbackPeacefulHelper: "1 = le moins paisible · 5 = le plus paisible",
    feedbackFixFirstPlaceholder: "Laissez votre commentaire ici*",
    feedbackSubmitBtn: "Envoyer l'avis",
    feedbackSendingBtn: "Envoi...",
    feedbackErrorName: "Veuillez entrer votre nom",
    feedbackErrorEmail: "Veuillez entrer un e-mail valide",
    feedbackErrorWalk: "Veuillez répondre : La Salle Arc-en-Ciel s'est-elle ouverte et avez-vous pu regarder autour de vous ?",
    feedbackErrorPeaceful: "Veuillez évaluer à quel point c'était paisible",
    feedbackErrorFixFirst: "Veuillez nous dire quoi corriger d'abord",

    shareInviteLabel: "Vous connaissez un autre Gardien ? Partagez ceci avec lui :",
    shareMessage: "Je viens de rejoindre la liste d'attente des Gardiens Petechtor — protéger les animaux, honorer leur mémoire pour toujours. Rejoignez-moi :",
    shareCopyLink: "Copier le Lien",
    shareCopied: "Copié !",

    footerCopyright: "© Gardiens du Petverse. Protéger ici-bas, honorer à jamais.",
    footerDisclaimer: "Petechtor est un projet axé sur la communauté dédié à la protection des animaux. Faites toujours vos propres recherches.",

    personalLogoUploadTooltip: "Téléchargez la photo de votre animal",
    personalLogoUploadTitle: "Télécharger la Photo",
    personalLogoReset: "Réinitialiser par Défaut",
    personalLogoVisibleOnly: "Visible uniquement par vous",

    clockCaption: "Chaque Seconde Compte.",
    clockUploadHint: "Touchez la photo d'une aiguille pour ajouter votre animal",
    clockUploadLogoBtn: "Télécharger le Logo",
    clockUseDefaultCrestBtn: "Utiliser l'Emblème par Défaut",
    clockHandUploadTooltip: "Téléchargez une photo d'animal",
    clockCenterLogoTooltip: "Téléchargez un logo central personnalisé"
  },

  pt: {
    petechtor: "PETECHTOR",
    guardiansOfPets: "Guardiões de Animais",
    rainbowRoomNav: "Sala do Arco-Íris",
    howItWorksNav: "Como funciona",
    joinGuardians: "Junte-se aos Guardiões",

    heroProtectWhileHere: "Proteger Enquanto Estão Aqui",
    heroHonorForever: "Honrar Para Sempre",

    heroBadgeRainbowRoom: "Sala do Arco-Íris",
    heroBadgeNoPetLeft: "Nenhum animal deixado atrás",

    heroSubtitle: "Uma missão sagrada: proteger cada animal hoje, honrar sua memória para sempre.",
    heroGuardiansOfPetverse: "Guardiões do Petverso",

    heroDescriptionPre: "A Petechtor defende uma verdade simple:",
    heroDescriptionBold: "proteger enquanto estão aqui, honrar para sempre.",
    heroDescriptionPost: "Ajudamos os guardiões a cuidar dos animais que nos dão tudo — e quando chega a hora, a Sala do Arco-Íris oferece um lugar sagrado para honrar sua memória.",

    heroBetaInviteBadge: "Aberto",
    heroBetaInviteTitle: "O primeiro memorial 3D real para animais que você pode entrar e viver como uma cena viva.",
    heroBetaInviteText: "Aberto. Um jardim compartilhado. Sugar permanece na Demo. Entre, ouça o Echo e abra uma memória.",
    heroBetaInviteText2: "Você pode adicionar uma foto do seu animal, assim como na Demo.",
    heroBetaInviteText3: "Basta clicar em \"Solicitar um lugar\". Não custa nada.",
    rainbowRoomPopupText: "Você concluiu a etapa 1 na Sala do Arco-Íris. Para adicionar seu pet, mais duas coisas são necessárias: deixe seu feedback abaixo e entre na lista de espera. Ambas são necessárias antes que seu pet possa ser adicionado.",
    rainbowRoomPopupFeedbackBtn: "Deixar feedback",
    rainbowRoomPopupWaitlistBtn: "Entrar na lista",

    heroEnterBeta: "Entrar no jardim",
    heroJoinGuardiansBtn: "🐾 Junte-se aos Guardiões",
    heroPrivateBetaNote: "Caminhe pelo jardim da Sugar. Ela faleceu. Isso é para você sentir uma sala. O passeio não é o lugar do seu animal.",

    heroWhyWeProtect: "Por Que Protegemos",
    heroWhyWeProtectText: "Nossos animais nos protegem sem pensar. Ficam ao nosso lado quando estamos para baixo, nos guardam quando temos medo, e dão todo o coração incondicionalmente. Esse é o vínculo silencioso que defendemos. Como Guardiões da Petechtor, nós os protegemos de volta — porque a razão pela qual devemos sempre proteger nossos animais é que eles nos protegem sem hesitar. Assim, cada Guardião é protetor e protegido ao mesmo tempo.",

    heroAsideBadge: "Aberto",
    heroAsideTitle: "A SALA DO ARCO-ÍRIS",
    heroAsideText: "Aberto. Um jardim. Um lugar para um animal que ainda está aqui, ou para um que já faleceu.",
    heroAsideEnterBeta: "Entrar no jardim",
    heroTagMemorial: "Tributos Memoriais",
    heroTagCommunity: "Apoio da Comunidade",
    heroTagFeedback: "Feedback Bem-vindo",
    heroAsideFooterNote: "Futuros serviços de guardiões — ferramentas reais de proteção e apoio da comunidade — se conectarão através da plataforma principal da Petechtor, sempre ao serviço desta mesma missão.",

    // Three Pillars
    pillarsCoreLanes: "Frentes principais",
    pillarsHeading: "Proteção hoje. Honra para sempre.",
    pillarsLegend: "Aberto = ativo agora com seu feedback · Futuro = planejado",
    pillarRainbowRoomDesc: "Aberto. Um jardim. Um lugar para um animal que ainda está aqui, ou para um que já faleceu.",
    pillarStatusPrivateBeta: "Aberto",
    pillarSupaGeneTitle: "SupaGene DNA",
    pillarSupaGeneDesc: "Uma futura adição para verificação de identidade de animais — detalhes compartilhados conforme nossa comunidade cresce.",
    pillarStatusFuture: "Futuro",
    pillarCommunityFundingTitle: "Financiamento Comunitário",
    pillarCommunityFundingDesc: "Futuros fluxos de doação e apoio a resgates, conectados através da plataforma principal da Petechtor.",
    pillarEnterBeta: "Entrar no jardim →",

    howItWorksLabel: "Como os Guardiões Agem",
    howItWorksHeading: "De um momento compartilhado à proteção real.",
    stepWord: "Passo",
    step1Title: "Compartilhe a história deles",
    step1Desc: "Compartilhe uma foto ou memória do seu animal — um momento feliz, uma história de resgate ou uma homenagem para a Sala do Arco-Íris.",
    step2Title: "Reivindique benefícios de Guardião",
    step2Desc: "Ganhe emblemas, sorteios e acesso por participar: homenagens, votos, envios de DNA e campanhas de emergência.",
    step3Title: "Encaminhe as bênçãos",
    step3Desc: "O apoio flui para parceiros de resgate, cuidados memoriais, e a infraestrutura que mantém cada história de animal online — para sempre.",

    trustLabel: "Confiança e Transparência",
    trustHeading: "Feito para Cada Guardião – Transparência Total",
    trust1Title: "Comunidade Primeiro",
    trust1Desc: "Sem agendas ocultas — feito para guardiões, não para lucro",
    trust2Title: "Roteiro Aberto",
    trust2Desc: "Planos compartilhados abertamente conforme nossa comunidade e a Sala do Arco-Íris crescem",
    trust3Title: "Valores do Guardião",
    trust3Desc: "Compaixão primeiro — não é aconselhamento financeiro",
    trust4Title: "Proteção Primeiro",
    trust4Desc: "Defendemos cada animal, incondicionalmente",

    joinHeading: "Junte Sua Pata & Garra – Torne-se um Guardião",
    joinStandWithUs: "Fique ao nosso lado para proteger cada animal.",
    joinText1: "Gratuito, para um animal que está aqui ou um que já faleceu. Abrimos lugares poucos por vez. O seu permanece.",
    joinText2: "Nossos animais nos protegem sem pensar, então os protegemos de volta — incondicionalmente.",
    joinText3: "Receba atualizações antecipadas quando houver mais a compartilhar, e ajude a moldar a missão como comunidade quando chegar a hora.",
    joinDetailsStay: "Seus dados ficam com a gente. Sem spam, só boas vibrações de proteção.",
    joinPledgeLabel: "Adesão e Compromisso do Guardião",
    joinNamePlaceholder: "Seu nome",
    joinEmailPlaceholder: "voce@exemplo.com",
    joinNotePlaceholder: "Interesse / nota breve",
    joinErrorName: "Por favor, insira seu nome",
    joinErrorEmail: "Por favor, insira seu e-mail",
    joinErrorValidEmail: "Por favor, insira um e-mail válido",
    joinErrorFailed: "Falha ao entrar na lista de espera",
    joinSuccessMsg: "✓ Você entrou na lista de espera com sucesso!",
    joinSubmitBtn: "Solicitar um lugar",
    joinSubmittingBtn: "Entrando...",
    joinJoinedBtn: "Adicionado ✓",
    joinClearBtn: "Limpar",

    feedLabel: "Feed dos Guardiões",
    feedHeading: "Os Guardiões alimentam a linha do tempo.",

    petverseHeading: "Prévia do Petverso",
    petverseText: "Um olhar por trás das cenas de como estamos construindo formas de proteger e defender cada companheiro — juntos.",
    petverseVisit: "Visite petechtor.com",

    feedbackHeading: "Depois de você ter entrado",
    feedbackSuccess: "Obrigado, Guardião. Assumimos a vigília.",
    feedbackNamePlaceholder: "Nome*",
    feedbackEmailPlaceholder: "E-mail*",
    feedbackPetNamePlaceholder: "Nome do animal",
    feedbackWalkQuestion: "A Sala do Arco-Íris abriu e você conseguiu olhar em volta?*",
    feedbackWalkYes: "Sim",
    feedbackWalkMostly: "Quase",
    feedbackWalkNo: "Não",
    feedbackPeacefulQuestion: "Foi tranquilo? (1-5)*",
    feedbackPeacefulHelper: "1 = menos tranquilo · 5 = mais tranquilo",
    feedbackFixFirstPlaceholder: "Deixe seu comentário aqui*",
    feedbackSubmitBtn: "Enviar feedback",
    feedbackSendingBtn: "Enviando...",
    feedbackErrorName: "Por favor, insira seu nome",
    feedbackErrorEmail: "Por favor, insira um e-mail válido",
    feedbackErrorWalk: "Por favor, responda: A Sala do Arco-Íris abriu e você conseguiu olhar em volta?",
    feedbackErrorPeaceful: "Por favor, avalie o quão tranquilo foi",
    feedbackErrorFixFirst: "Por favor, diga o que corrigir primeiro",

    shareInviteLabel: "Conhece outro Guardião? Compartilhe isso com ele:",
    shareMessage: "Acabei de entrar na lista de espera dos Guardiões Petechtor — protegendo animais, honrando sua memória para sempre. Junte-se a mim:",
    shareCopyLink: "Copiar Link",
    shareCopied: "Copiado!",

    footerCopyright: "© Guardiões do Petverso. Proteger enquanto estão aqui, honrar para sempre.",
    footerDisclaimer: "A Petechtor é um projeto voltado para a comunidade focado em proteger animais. Sempre faça sua própria pesquisa.",

    personalLogoUploadTooltip: "Envie a foto do seu animal",
    personalLogoUploadTitle: "Enviar Foto do Animal",
    personalLogoReset: "Restaurar Padrão",
    personalLogoVisibleOnly: "Visível apenas para você",

    clockCaption: "Cada Segundo Importa.",
    clockUploadHint: "Toque na foto de uma mão para adicionar seu animal",
    clockUploadLogoBtn: "Enviar Logo",
    clockUseDefaultCrestBtn: "Usar Brasão Padrão",
    clockHandUploadTooltip: "Envie a foto de um animal",
    clockCenterLogoTooltip: "Envie um logo central personalizado"
  },

  de: {
    petechtor: "PETECHTOR",
    guardiansOfPets: "Hüter der Haustiere",
    rainbowRoomNav: "Regenbogenraum",
    howItWorksNav: "So funktioniert's",
    joinGuardians: "Werde ein Hüter",

    heroProtectWhileHere: "Schützen, Solange Sie Da Sind",
    heroHonorForever: "Für Immer Ehren",

    heroBadgeRainbowRoom: "Regenbogenraum",
    heroBadgeNoPetLeft: "Kein Haustier wird zurückgelassen",

    heroSubtitle: "Eine heilige Mission: jedes Haustier heute schützen, sein Andenken für immer ehren.",
    heroGuardiansOfPetverse: "Hüter des Petverse",

    heroDescriptionPre: "Petechtor steht für eine einfache Wahrheit:",
    heroDescriptionBold: "schützen, solange sie da sind, für immer ehren.",
    heroDescriptionPost: "Wir helfen Hütern, sich um die Haustiere zu kümmern, die uns alles geben — und wenn die Zeit kommt, bietet der Regenbogenraum einen heiligen Ort, um ihr Andenken zu ehren.",

    heroBetaInviteBadge: "Offen",
    heroBetaInviteTitle: "Das erste echte 3D-Haustier-Denkmal, das du betreten und als lebendige Szene erleben kannst.",
    heroBetaInviteText: "Offen. Ein gemeinsamer Garten. Sugar bleibt in der Demo. Geh hinein, hör Echo und öffne eine Erinnerung.",
    heroBetaInviteText2: "Du kannst ein Foto deines Haustiers hinzufügen, genau wie in der Demo.",
    heroBetaInviteText3: "Klicke einfach auf „Platz anfragen“. Es kostet dich nichts.",
    rainbowRoomPopupText: "Du hast Schritt 1 im Regenbogenraum abgeschlossen. Um dein Haustier hinzuzufügen, sind zwei weitere Dinge nötig: Hinterlasse unten dein Feedback und tritt der Warteliste bei. Beides ist erforderlich, bevor dein Haustier hinzugefügt werden kann.",
    rainbowRoomPopupFeedbackBtn: "Feedback hinterlassen",
    rainbowRoomPopupWaitlistBtn: "Warteliste beitreten",

    heroEnterBeta: "Den Garten betreten",
    heroJoinGuardiansBtn: "🐾 Werde ein Hüter",
    heroPrivateBetaNote: "Geh durch Sugars Garten. Sie ist verstorben. So kannst du einen Raum fühlen. Der Rundgang ist nicht der Platz deines Haustiers.",

    heroWhyWeProtect: "Warum Wir Schützen",
    heroWhyWeProtectText: "Unsere Haustiere schützen uns ohne zu zögern. Sie stehen uns bei, wenn wir niedergeschlagen sind, wachen über uns, wenn wir Angst haben, und geben ihr ganzes Herz bedingungslos. Das ist die stille Bindung, für die wir stehen. Als Petechtor-Hüter schützen wir sie zurück — denn der eine Grund, warum wir unsere Haustiere immer beschützen sollten, ist, dass sie uns ohne zu zögern beschützen. So ist jeder Hüter zugleich Beschützer und Beschützter.",

    heroAsideBadge: "Offen",
    heroAsideTitle: "DER REGENBOGENRAUM",
    heroAsideText: "Offen. Ein Garten. Ein Platz für ein Haustier, das noch hier ist, oder für eines, das verstorben ist.",
    heroAsideEnterBeta: "Den Garten betreten",
    heroTagMemorial: "Gedenktribute",
    heroTagCommunity: "Community-Unterstützung",
    heroTagFeedback: "Feedback Willkommen",
    heroAsideFooterNote: "Zukünftige Hüter-Dienste — echte Schutzwerkzeuge und Community-Unterstützung — werden über die Haupt-Petechtor-Plattform verbunden, stets im Dienst dieser gleichen Mission.",

    // Three Pillars
    pillarsCoreLanes: "Kernbereiche",
    pillarsHeading: "Schutz heute. Ehre für immer.",
    pillarsLegend: "Offen = jetzt live mit deinem Feedback · Zukunft = geplant",
    pillarRainbowRoomDesc: "Offen. Ein Garten. Ein Platz für ein Haustier, das noch hier ist, oder für eines, das verstorben ist.",
    pillarStatusPrivateBeta: "Offen",
    pillarSupaGeneTitle: "SupaGene DNA",
    pillarSupaGeneDesc: "Eine zukünftige Ergänzung zur Verifizierung der Haustier-Identität — Details werden geteilt, sobald unsere Community wächst.",
    pillarStatusFuture: "Zukunft",
    pillarCommunityFundingTitle: "Community-Finanzierung",
    pillarCommunityFundingDesc: "Zukünftige Spenden- und Rettungsunterstützungs-Flüsse, verbunden über die Haupt-Petechtor-Plattform.",
    pillarEnterBeta: "Den Garten betreten →",

    howItWorksLabel: "So Handeln die Hüter",
    howItWorksHeading: "Von einem geteilten Moment zu echtem Schutz.",
    stepWord: "Schritt",
    step1Title: "Teile seine Geschichte",
    step1Desc: "Teile ein Foto oder eine Erinnerung an dein Haustier — einen freudigen Moment, eine Rettungsgeschichte oder ein Tribut für den Regenbogenraum.",
    step2Title: "Hüter-Vorteile einlösen",
    step2Desc: "Verdiene Abzeichen, Verlosungen und Zugang durch Teilnahme: Tribute, Abstimmungen, DNA-Einreichungen und Notfallkampagnen.",
    step3Title: "Segen weiterleiten",
    step3Desc: "Unterstützung fließt zu Rettungspartnern, Gedenkpflege und der Infrastruktur, die jede Haustiergeschichte online hält — für immer.",

    trustLabel: "Vertrauen und Transparenz",
    trustHeading: "Für Jeden Hüter Gemacht – Volle Transparenz",
    trust1Title: "Community-First",
    trust1Desc: "Keine versteckten Absichten — gemacht für Hüter, nicht für Profit",
    trust2Title: "Offene Roadmap",
    trust2Desc: "Pläne offen geteilt, während unsere Community und der Regenbogenraum wachsen",
    trust3Title: "Hüter-Werte",
    trust3Desc: "Mitgefühl zuerst — keine Finanzberatung",
    trust4Title: "Schutz Zuerst",
    trust4Desc: "Wir stehen bedingungslos für jedes Haustier",

    joinHeading: "Bring Deine Pfote & Kralle Ein – Werde ein Hüter",
    joinStandWithUs: "Steh uns bei, um jedes Haustier zu schützen.",
    joinText1: "Kostenlos, für ein Haustier, das hier ist, oder eines, das verstorben ist. Wir öffnen Plätze nur wenige auf einmal. Deiner bleibt.",
    joinText2: "Unsere Haustiere schützen uns ohne zu zögern, also schützen wir sie zurück — bedingungslos.",
    joinText3: "Erhalte frühe Updates, wenn es mehr zu teilen gibt, und hilf mit, die Mission als Community zu gestalten, wenn die Zeit reif ist.",
    joinDetailsStay: "Deine Daten bleiben bei uns. Kein Spam, nur Schutz-Vibes.",
    joinPledgeLabel: "Hüter-Beitritt & Zusage",
    joinNamePlaceholder: "Dein Name",
    joinEmailPlaceholder: "du@beispiel.com",
    joinNotePlaceholder: "Interesse / kurze Notiz",
    joinErrorName: "Bitte gib deinen Namen ein",
    joinErrorEmail: "Bitte gib deine E-Mail ein",
    joinErrorValidEmail: "Bitte gib eine gültige E-Mail ein",
    joinErrorFailed: "Beitritt zur Warteliste fehlgeschlagen",
    joinSuccessMsg: "✓ Erfolgreich der Warteliste beigetreten!",
    joinSubmitBtn: "Platz anfragen",
    joinSubmittingBtn: "Wird beigetreten...",
    joinJoinedBtn: "Beigetreten ✓",
    joinClearBtn: "Löschen",

    feedLabel: "Hüter-Feed",
    feedHeading: "Die Hüter füllen den Feed.",

    petverseHeading: "Blick hinter die Kulissen des Petverse",
    petverseText: "Ein Blick hinter die Kulissen, wie wir Wege schaffen, um jeden Begleiter zu schützen und für ihn einzustehen — gemeinsam.",
    petverseVisit: "Besuche petechtor.com",

    feedbackHeading: "Nachdem du drinnen warst",
    feedbackSuccess: "Danke, Hüter. Wir haben die Wache übernommen.",
    feedbackNamePlaceholder: "Name*",
    feedbackEmailPlaceholder: "E-Mail*",
    feedbackPetNamePlaceholder: "Name des Haustiers",
    feedbackWalkQuestion: "Hat sich der Regenbogenraum geöffnet und konntest du dich umsehen?*",
    feedbackWalkYes: "Ja",
    feedbackWalkMostly: "Größtenteils",
    feedbackWalkNo: "Nein",
    feedbackPeacefulQuestion: "Friedlich? (1-5)*",
    feedbackPeacefulHelper: "1 = am wenigsten friedlich · 5 = am friedlichsten",
    feedbackFixFirstPlaceholder: "Hinterlasse hier dein Feedback*",
    feedbackSubmitBtn: "Feedback senden",
    feedbackSendingBtn: "Wird gesendet...",
    feedbackErrorName: "Bitte gib deinen Namen ein",
    feedbackErrorEmail: "Bitte gib eine gültige E-Mail ein",
    feedbackErrorWalk: "Bitte beantworte: Hat sich der Regenbogenraum geöffnet und konntest du dich umsehen?",
    feedbackErrorPeaceful: "Bitte bewerte, wie friedlich es sich angefühlt hat",
    feedbackErrorFixFirst: "Bitte sag uns, was zuerst behoben werden soll",

    shareInviteLabel: "Kennst du einen anderen Hüter? Teile das mit ihm:",
    shareMessage: "Ich bin gerade der Petechtor-Hüter-Warteliste beigetreten — Haustiere schützen, ihr Andenken für immer ehren. Mach mit:",
    shareCopyLink: "Link Kopieren",
    shareCopied: "Kopiert!",

    footerCopyright: "© Hüter des Petverse. Schützen, solange sie da sind, für immer ehren.",
    footerDisclaimer: "Petechtor ist ein community-orientiertes Projekt zum Schutz von Haustieren. Informiere dich immer selbst.",

    personalLogoUploadTooltip: "Lade das Foto deines Haustiers hoch",
    personalLogoUploadTitle: "Haustierfoto Hochladen",
    personalLogoReset: "Auf Standard Zurücksetzen",
    personalLogoVisibleOnly: "Nur für dich sichtbar",

    clockCaption: "Jede Sekunde Zählt.",
    clockUploadHint: "Tippe auf das Foto eines Zeigers, um dein Haustier hinzuzufügen",
    clockUploadLogoBtn: "Logo Hochladen",
    clockUseDefaultCrestBtn: "Standard-Wappen Verwenden",
    clockHandUploadTooltip: "Ein Haustierfoto hochladen",
    clockCenterLogoTooltip: "Ein individuelles Zentrallogo hochladen"
  }
};
